import { render } from "./Top_title_statistics.vue?vue&type=template&id=31714ac2&scoped=true"
import script from "./Top_title_statistics.vue?vue&type=script&lang=js"
export * from "./Top_title_statistics.vue?vue&type=script&lang=js"

import "./Top_title_statistics.vue?vue&type=style&index=0&id=31714ac2&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31714ac2"]])

export default __exports__